export const CASH_OUT_DAYS_LIMIT = 60;
export const ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000;

export const DOCUMENT_REQUEST_STATUS_FULFILLED = 'fulfilled';

export const FINANCE_SETTINGS = 'finance-settings';
export const BANK_ACCOUNTS = 'bank-accounts';
export const ORGANIZATIONS = 'organizations';
export const TAXPAYER_INFO = 'taxpayer-info';

export const LOCALLY_STORED_TAXPAYER_REQUEST_STATUS_KEY =
    'locally_stored_taxpayer_request_status';
export const FINANCE_NOTIFICATION_MODAL_SEEN =
    'finance_notification_modal_seen';

export const EVENT_TAXPAYER_INFORMATION_ADDED =
    'taxpayer_form:information_added';
export const EVENT_BANK_ACCOUNT_ADDED = 'bank_account_form:added';

export enum WorkspaceTypes {
    CREATOR_HOME = 'creatorHome',
    EVENTS = 'events',
    ORDERS = 'orders',
    MARKETING = 'marketing',
    REPORTS = 'reports',
    FINANCE = 'finance',
    ONBOARDING = 'onboarding',
    ORGANIZATION = 'organization',
    SWITCH_ORGANIZATION = 'switchOrganization',
}

export enum DocumentRequestStatusTypes {
    FULFILLED = 'fulfilled',
    WANTED = 'wanted',
    NEEDED = 'needed',
    NONE = 'none',
    MISMATCHED = 'mismatched',
    LOCKED = 'locked',
}

const FIVE_MINUTES = 5 * 60 * 1000;
export const DEFAULT_QUERYCLIENT_OPTIONS = {
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: FIVE_MINUTES,
        },
    },
};
